(function () {
  console.log('Card swatches script loaded');
  
  function showVariant(cardWrapper, id) {
    if (!cardWrapper) {
      console.log('No cardWrapper found');
      return;
    }
    
    console.log('Showing variant:', id);
    
    // Find all variant images within this card wrapper
    const allImages = cardWrapper.querySelectorAll('.card__variant-image');
    console.log('Found variant images:', allImages.length);
    
    allImages.forEach((img) => {
      img.style.opacity = '0';
      img.style.zIndex = '1';
    });

    // Show the selected variant image
    const active = cardWrapper.querySelector(`.card__variant-image[data-variant-id="${id}"]`);
    if (active) {
      console.log('Found active variant image, showing it');
      active.style.opacity = '1';
      active.style.zIndex = '3';
    } else {
      console.log('No variant image found for ID:', id);
    }
  }

  function resetCard(cardWrapper) {
    if (!cardWrapper) return;
    
    console.log('Resetting card');
    cardWrapper.querySelectorAll('.card__variant-image').forEach((img) => {
      img.style.opacity = '0';
      img.style.zIndex = '1';
    });
  }

  document.addEventListener('mouseover', (e) => {
    const swatch = e.target.closest('.card__swatch');
    if (!swatch) return;

    console.log('Swatch hovered');

    // Get the card-wrapper (the top-level parent)
    const cardWrapper = swatch.closest('.card-wrapper');
    if (!cardWrapper) {
      console.log('No card-wrapper found');
      return;
    }

    const id = swatch.getAttribute('data-variant-id');
    console.log('Variant ID:', id);
    if (!id) return;

    showVariant(cardWrapper, id);
  });

  document.addEventListener('mouseout', (e) => {
    const swatches = e.target.closest('.card__swatches');
    if (!swatches) return;

    if (e.relatedTarget && swatches.contains(e.relatedTarget)) return;

    const cardWrapper = swatches.closest('.card-wrapper');
    if (!cardWrapper) return;

    resetCard(cardWrapper);
  });
// Disable Dawn's built-in hover effect for cards with swatches
function disableHoverEffect() {
  document.querySelectorAll('.card--has-swatches .media--hover-effect').forEach(media => {
    media.classList.remove('media--hover-effect');
  });
}

// Run on load
disableHoverEffect();

// Re-run after filters update
document.addEventListener('shopify:section:load', disableHoverEffect);

// Watch for product grid changes (when filters are applied)
const productGrid = document.querySelector('#product-grid, .collection, [id*="product-grid"]');
if (productGrid) {
  const gridObserver = new MutationObserver(() => {
    setTimeout(disableHoverEffect, 100);
  });
  
  gridObserver.observe(productGrid, { 
    childList: true, 
    subtree: true 
  });
}

})();
